"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadiationCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RadiationCircleFilled = function RadiationCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10.508L4.983 13.5s-1.541-.333-2.435-1.835c-.895-1.502-.424-2.967-.424-2.967l3.68-.198c.013.392.122.786.339 1.15.216.363.514.652.857.858zm6.875-1.81l-3.68-.198a2.394 2.394 0 01-.338 1.15 2.486 2.486 0 01-.857.858l2.017 2.992s1.543-.337 2.437-1.84c.894-1.501.421-2.962.421-2.962zM8 6.298c.454 0 .88.11 1.255.302L11 3.275S9.875 2.1 7.998 2.1C6.12 2.1 5 3.275 5 3.275L6.746 6.6A2.73 2.73 0 018 6.297zM8 7a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: "currentColor"
  }));
};

exports.RadiationCircleFilled = RadiationCircleFilled;
var _default = RadiationCircleFilled;
exports.default = _default;